/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './fusion-widget.scss';
import './modifier/with-animation.scss';
import './modifier/with-spacing.scss';
